import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Krets from './Krets.jsx'
import KretsIcon from '../../../images/Krets.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class KretsList extends Component {
    state = {
        kretser: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null
    }

    getKretser = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/adresse/${this.props.adresseId}/krets`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                kretser: [...this.state.kretser, ...data.kretser],
                isLoading: false,
                continuationToken: data.nextContinuationToken})
        })
      }


    toggleKretser = () => {
        if (this.props.antall == 0) return
                
        if (this.state.kretser.length == 0) {
            this.getKretser()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var antallKretser = this.state.continuationToken ? `${this.state.kretser.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleKretser}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={KretsIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('kretser')} ({antallKretser})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.kretser.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.kretser.map((k, index) => { return (<Krets key={k.kretsId} krets={k} antall={this.props.antall} isLast={index==this.state.kretser.length-1} onEvent={this.props.onEvent} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getKretser}>
                                <span>{t('hent.kretser')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(KretsList)